export const darkModeClass = (styles, isDarkMode) =>
  isDarkMode ? styles.dark : '';
